import Grid from "@mui/material/Grid/Grid";
import Paper from "@mui/material/Paper/Paper";
import Box from "@mui/material/Box/Box";
import {CustomLabelSmallMedium, CustomLabelXSmallRegular} from "../common/CustomLabel";
import {CustomTextField, CustomTextMultipleField} from "../common/text";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import USER from "../../assets/images/user.png";
import MAIL_BLACK from "../../assets/images/mail-black.png";
import SEND from "../../assets/images/send.png";
import CALENDAR from "../../assets/images/calendar.png";
import React, {useState} from "react";
import {useMediaQuery} from "@mui/material";
import createTheme from "@mui/material/styles/createTheme";
import {transformValidateObject, validateUserInput} from "../../utils";

import {collection, addDoc} from "firebase/firestore";
import {db} from "src/firebase/firebaseConfig";
import Loader from "../common/Loader";

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 710,
            md: 950,
            lg: 1300,
            xl: 1350,
        },
    },
});

const initialContactUsData = {
    full_name: {value: '', showError: false, error: 'Field cant be empty'},
    email: {value: '', showError: false, error: 'Field cant be empty'},
    subject: {value: '', showError: false, error: 'Field cant be empty'},
    message: {value: '', showError: false, error: 'Field cant be empty'},

}


const ContactUs = ({
                       setShowConfirmation
                   }) => {

    const [contactUs, setContactUs] = useState(initialContactUsData);
    const [isLoading, setIsLoading] = useState(false);
    const [count, setCount] = useState(0);


    const saveProject = async (database, data) => {
        try {
            await addDoc(collection(db, database), {...data, createdAt: new Date()});

        } catch (error) {
            console.error("Error saving project:", error);
        }
    };


    const onChange = (e, type) => {
        let data;
        let value = e.target.value


        data = {...contactUs, [type]: {...contactUs[type], value: value}};
        setContactUs(data);
    }


    const onSubmit = async (e) => {
        const validate = validateUserInput(contactUs);

        if (validate.isValid) {

            const data = {...transformValidateObject(contactUs)}

            setIsLoading(true)
            await saveProject("contact-us", data)
            setIsLoading(false)
            setShowConfirmation(true);
            setContactUs(initialContactUsData);
            setCount(count+1)

        } else {
            setContactUs(validate.data);
            setCount(count + 1);
        }
    }

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <>
            {isLoading && <Loader/>}
            <Grid item xs={12} lg={6.8} sx={{marginTop: {xs: "20px", lg: "0px"}}} container alignItems={"center"}>
                <Paper
                    style={{width: "100%", background: "white", borderRadius: 20, padding: "0px 0px 0px 0px"}}>
                    <Box component={"form"} sx={{padding: {xs: "20px", md: "35px 20px"}}}>
                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                            <Grid item xs={12} md={5.8} container justifyContent={"flex-start"}>
                                <Grid item style={{marginLeft: 10}}>
                                    <CustomLabelXSmallRegular text={"Full Name"}/>
                                </Grid>
                                <Grid item container style={{marginTop: 5}}>
                                    <CustomTextField placeholder={"Type your full name here..."}
                                                     height={isMobile && "50px"}
                                                     value={contactUs.full_name.value}
                                                     onChange={(e) => onChange(e, 'full_name')}
                                                     error={contactUs.full_name.showError}
                                                     helperText={contactUs.full_name.showError ? contactUs.full_name.error : ""}
                                                     startAdornment={
                                                         <InputAdornment position="start">
                                                             <img src={USER} alt={"USER"}/>
                                                         </InputAdornment>

                                                     }/>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={5.8} sx={{marginTop: {xs: "10px", md: "0px"}}} container
                                  justifyContent={"flex-start"}>
                                <Grid item style={{marginLeft: 10}}>
                                    <CustomLabelXSmallRegular text={"Email Address"}/>
                                </Grid>
                                <Grid item container style={{marginTop: 5}}>
                                    <CustomTextField placeholder={"example@email.com"}
                                                     height={isMobile && "50px"}
                                                     value={contactUs.email.value}
                                                     onChange={(e) => onChange(e, 'email')}
                                                     error={contactUs.email.showError}
                                                     helperText={contactUs.email.showError ? contactUs.email.error : ""}
                                                     startAdornment={
                                                         <InputAdornment position="start">
                                                             <img src={MAIL_BLACK} alt={"MAIL_BLACK"}/>
                                                         </InputAdornment>

                                                     }/>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Subject"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomTextField
                                    value={contactUs.subject.value}
                                    onChange={(e) => onChange(e, 'subject')}
                                    error={contactUs.subject.showError}
                                    helperText={contactUs.subject.showError ? contactUs.subject.error : ""}
                                    placeholder={"Type your topic of discussion..."}/>
                            </Grid>
                        </Grid>
                        <Grid container style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Message"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomTextMultipleField
                                    value={contactUs.message.value}
                                    onChange={(e) => onChange(e, 'message')}
                                    error={contactUs.message.showError}
                                    helperText={contactUs.message.showError ? contactUs.message.error : ""}
                                    placeholder={"What's on your mind?"} rows={5}/>
                            </Grid>
                        </Grid>
                        <Grid container justifyContent={{xs: "center", md: "space-between"}}
                              alignItems={"center"}
                              style={{marginTop: "25px"}}>
                            <Grid item xs={10} md={5.5} container alignItems={"center"}
                                  justifyContent={"center"}
                                  style={{
                                      border: "1.5px solid #F5F5F5",
                                      borderRadius: 15,
                                      padding: "12px 25px",
                                      background: "#5E17EB",
                                      cursor: "pointer"
                                  }}
                                  onClick={onSubmit}
                            >
                                <Grid item>
                                    <img src={SEND} alt={"SEND"}/>
                                </Grid>
                                <Grid item style={{marginLeft: "10px"}}>
                                    <CustomLabelSmallMedium text={"Send Message"} color={"white"}/>
                                </Grid>
                            </Grid>


                            <Grid item container justifyContent={"center"}
                                  sx={{display: {xs: "flex", md: "none"}, marginTop: {xs: "10px", md: "0px"}}}>
                                <CustomLabelXSmallRegular color={"#A3A3A3"} normal={true}
                                                          text={"OR"}
                                />

                            </Grid>

                            <Grid item sx={{display: {xs: "none", md: "flex"}}}>
                                <CustomLabelXSmallRegular color={"#A3A3A3"} normal={true}
                                                          text={"OR"}
                                />

                            </Grid>
                            <Grid 
                                item 
                                xs={10} 
                                md={5.5} 
                                sx={{ 
                                    marginTop: { xs: "10px", md: "0px" } 
                                }}
                            >
                                <Box
                                    component="a"
                                    href="https://calendly.com/ostryx-info/30min"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        textDecoration: 'none',
                                        display: 'block'
                                    }}
                                >
                                    <Grid 
                                        container
                                        alignItems="center" 
                                        justifyContent="center"
                                        sx={{
                                            border: "1.5px solid #F5F5F5",
                                            borderRadius: 15,
                                            padding: "12px 25px",
                                            background: "#5E17EB",
                                            cursor: "pointer",
                                            transition: 'background 0.3s ease',
                                            '&:hover': {
                                                background: '#4912b9'
                                            }
                                        }}
                                    >
                                        <Grid item>
                                            <Box
                                                component="img"
                                                src={CALENDAR}
                                                alt="Calendar Icon"
                                            />
                                        </Grid>
                                        <Grid item sx={{ ml: 1.25 }}>
                                            <CustomLabelSmallMedium 
                                                text="Schedule a Call" 
                                                color="white"
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>

                        </Grid>

                    </Box>
                </Paper>
            </Grid>
        </>
    )
}

export default ContactUs
